import { useState } from "react";

import "./Projects.css";

import channelImage from "../img/channel.png";
import cabinetImage from "../img/cabinet.png";
import windowImage from "../img/window.png";

const projects = [

    {
        image: channelImage,
        title: "Channel Letters",
        company: "ClearWave Medical"
    },

    {
        image: cabinetImage,
        title: "Cabinet Sign",
        company: "Northern Market"
    },

    {
        image: windowImage,
        title: "Window Graphics",
        company: "Luna Café"
    }

];

function Projects() {

    const [selectedProject, setSelectedProject] = useState(null);

    return (

        <>

            <div className="projects-container">

                <span className="section-tag">
                    FEATURED PROJECTS
                </span>

                <h2>
                    Quality You Can See
                </h2>

                <p className="projects-intro">

                    Explore a selection of recent signage projects completed
                    across Canada for retail, commercial and corporate clients.

                </p>

                <div className="projects-grid">

                    {projects.map((project, index) => (

                        <div className="project-card" key={index}>

                            <div className="project-image">

                                <img
                                    src={project.image}
                                    alt={project.company}
                                />

                            </div>

                            <div className="project-content">

                                <h3>{project.title}</h3>

                                <p>{project.company}</p>

                                <button
                                    onClick={() => setSelectedProject(project)}
                                >
                                    View Project
                                </button>

                            </div>

                        </div>

                    ))}

                </div>

            </div>

            {selectedProject && (

                <div
                    className="project-modal"
                    onClick={() => setSelectedProject(null)}
                >

                    <div
                        className="project-modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <button
                            className="project-close"
                            onClick={() => setSelectedProject(null)}
                        >

                            ×

                        </button>

                        <img
                            src={selectedProject.image}
                            alt={selectedProject.company}
                        />

                        <h2>

                            {selectedProject.title}

                        </h2>

                        <p>

                            {selectedProject.company}

                        </p>

                    </div>

                </div>

            )}

        </>

    );

}

export default Projects;